<template>
  <AppHeader>Delear Tranasction Summary</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div v-if="data.length != 0" class="py-2 bg-white rounded-lg shadow-md">
      <div v-for="item in data" :key="item.title" class="flex items-center justify-between px-3 mt-2 text-lg text-gray-600 hover:bg-gray-100">
        <p>{{ item.title }}</p>
        <p class="text-3xl text-gray-900">{{ item.value }}</p>
      </div>
    </div>

    <div v-else class="text-center text-gray-500">
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';

export default {
  name: 'ReportDealerTnxSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate },
  data() {
    return {
      state: 'idle',
      data: [],
    }
  },

  methods: {
    getData(from, to) {
      this.state = 'loading';

      this.request('GET', 'reports/dealertnx-summary?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
        } else alert(resp.message);
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
